export default {
    
    en: {
        title: 'Approval Management',
        performancetitle: 'Approval Performance',
        appSsid: 'App',
        allSettleCount: 'Number of repayments due',
        firstOverDueRate: 'First over rate',
        curDate:"date",
        T1colbackRate: 'T1 Real time overdue rate',
        T2colbackRate: 'T2 Real time overdue rate',
        T3colbackRate: 'T3 Real time overdue rate',
        T4colbackRate: 'T4 Real time overdue rate',
        T5colbackRate: 'T5 Real time overdue rate',
        T6colbackRate: 'T6 Real time overdue rate',
        T7colbackRate: 'T7 Real time overdue rate',
        T8colbackRate: 'T8 Real time overdue rate',
        T9colbackRate: 'T9 Real time overdue rate',
        T10colbackRate: 'T10 Real time overdue rate',
        T11colbackRate: 'T11 Real time overdue rate',
        T12colbackRate: 'T12 Real time overdue rate',
        T13colbackRate: 'T13 Real time overdue rate',
        T14colbackRate: 'T14 Real time overdue rate',
        T14OverbackRate: 'T14+ Real time overdue rate',
    }
}
